import { ApiClient, Paginated } from './client';

export type TakeoffItemTag = {
  id: number;
  name: string;
  description: string;
};

export class TakeoffItemTagsClient extends ApiClient {
  async getTags() {
    return this._get<Paginated<TakeoffItemTag>>('takeoff-item-tags/');
  }
}
